import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { GasDistributionStationType } from '@/features/gasDistributionStationType/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const gasDistributionStationTypeApi = createApi({
  reducerPath: 'gdStationTypeApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getGasDistributionStationTypes: builder.query<
      GasDistributionStationType[],
      any
    >({
      query: () => ({
        url: '/gas-distribution-station-types',
      }),
    }),
  }),
});

export const { useGetGasDistributionStationTypesQuery } =
  gasDistributionStationTypeApi;
